import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DataService } from '../../../core/data/data-service';
import { CommonService } from '../../../common/services/common.service';
import { AttractorLoopService } from '../../../core/routing/services/asset-library/attractor-loop.service';
import { GlobalConstants } from './../../../common/constants/global.constant';
import { RouterConstants } from './../../../core/routing/constants/app-paths.constant';
import { AttractorLoop, AttractorLoopConfiguration } from '../../asset-library/attractor-loop/interfaces/attractor-loop.i';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../environments/environment';
import { Utils } from 'src/app/common/utils/utils';

@Component({
  selector: 'iposcen-profile-attract-loop',
  templateUrl: './profile-attract-loop.component.html',
  styleUrls: ['./profile-attract-loop.component.scss']
})
export class ProfileAttractLoopComponent implements OnInit {
  @Output() readonly getSelectedAttractLoopData = new EventEmitter<any>();
  @Output() readonly getAttractLoopRecordCount = new EventEmitter<any>();
  @Output() readonly getShowDeviceNone = new EventEmitter<any>();
  @Input() readonly selectedAttractLoopId: string;
  userId = sessionStorage.getItem('userId');
  configurations: AttractorLoopConfiguration[];
  displayAttractorLoop = [];
  allAttractorLoop: AttractorLoop[];
  tabIndex = 0;
  labelY = GlobalConstants.YES;
  labelN = GlobalConstants.NO;
  // sideNav = 'store';
  sortValue = $localize`:@@attractor-loop.variable.create-date:Creation Date`;
  page = 1;
  pageSize = 5;
  attractorLoopToDelete: string;
  attractorLoopToDeleteName: string;
  attractorLoopData: object;
  pageGrpForm: any;
  mediaObjects: any[] = [];
  globalConstant = GlobalConstants;
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  attractorLoopPreviewFlag: boolean = false;
  selectedIndex;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private router: Router,
    private cmnService: CommonService,
    private dataService: DataService,
    private attractorLoopService: AttractorLoopService
  ) { }

  ngOnInit(): void {
    this.getAllAttractorLoopByUser();

    this.cmnService.emitRefreshProfileAttractLoopObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        this.getAllAttractorLoopByUser();
      });
    //IIT2-4663
    const pageName = this.router.url.lastIndexOf('/');
    if (this.router.url.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE ||
      this.router.url.includes(RouterConstants.EDIT_PROFILE) || this.router.url.includes(RouterConstants.DEVICE_SETTINGS) || this.router.url.includes(RouterConstants.DEVICE_DASHBOARD_LINK)) {
      this.attractorLoopPreviewFlag = true;
    }
  }

  // setSideNav(value: string) {
  //   this.sideNav = value;
  // }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getAllAttractorLoopByUser() {
    this.attractorLoopService.getAllAttractorLoopByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllAttractorLoopResponse => {
        this.allAttractorLoop = (getAllAttractorLoopResponse.attractLoop as AttractorLoop[]);
        this.getAttractLoopRecordCount.emit(this.allAttractorLoop?.length);
        this.configurations = [];
        this.allAttractorLoop.forEach(attractorLoopGroup => {
          try {
            this.configurations.push(JSON.parse(attractorLoopGroup.configurations) as AttractorLoopConfiguration);
          }
          catch (err) {
            console.log(err);
          }
        });

        // display Attractor loop using displayAttractorLoop var as configurations is coming as string
        this.displayAttractorLoop = [];
        this.allAttractorLoop.forEach(ele => {
          try {
            ele.configurations = JSON.parse(ele.configurations);
          }
          catch (err) {
            console.log(err);
          }
          ele.createdByUser = (ele.createdByUser === this.userId) ? GlobalConstants.ME : ele.createdByUser;
          this.displayAttractorLoop.push(ele);
        });
        this.displayAttractorLoop.forEach(element => {
          element.isExpanded = false;
          element.checked = element.id === this.selectedAttractLoopId;
          // For sorting
          if (element.updateTime) {
            element.updateTime = new Date(element.updateTime);
          }
          if (element && element.configurations && element.configurations.formFactor) {
            element.configurations.formFactor = Utils.getFormFactorNames(element.configurations.formFactor);
          }
          // For content expired notification
          element.isContentExpires = Utils.getExpiredUnChangedContentdata(element);
        });
        this.sortByDate();
        this.displayAttractorLoop.forEach((element, index) => {
          element.index = index;
        });
      },
        error => {
          // do something
          this.getAttractLoopRecordCount.emit(0);
        });
  }

  /* Delete attrat loop content */
  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  loadMiniPreview(gId: string) {
    this.pageGrpForm = {
      bgcolor: GlobalConstants.BG_COLOR_ATTRACTLOOP,
      heading: ' ',
      hcolor: GlobalConstants.BG_COLOR_ATTRACTLOOP,
      body: ' ',
      bcolor: GlobalConstants.BG_COLOR_ATTRACTLOOP,
      size: GlobalConstants.MEDIUM,
      media: {
        url:
          environment.apiBaseUrlAsset +
          this.url +
          AssetLibraryConstants.ATTRACTOR_LOOP +
          AssetLibraryConstants.SLASH +
          gId,
        name: '',
        format: 'video',
        fileObj: ''
      },
      id: gId, // adding created group id,
      layout: 3
    };
    //IIT2-4663
    this.pageGrpForm.media.alMiniPreview = this.attractorLoopPreviewFlag ? true : false;
    return this.pageGrpForm;
  }

  refreshAttractorLoopdata() {
    this.getAllAttractorLoopByUser();
  }

  getDetailsOfAttractorLoop(id: string) {
    this.displayAttractorLoop.forEach(element => {
      if (element.id === id) {
        element.isExpanded = !element.isExpanded;
      }
    });
  }

  sortByDate() {
    this.displayAttractorLoop.sort((loop1, loop2) => loop2?.updateTime - loop1?.updateTime);
    // To track existing selected attractloop  - iit2-9025
    for (let ind = 0; ind < this.displayAttractorLoop?.length; ind++) {
      if (this.displayAttractorLoop[ind]?.checked) {
        this.selectedIndex = ind;
        break;
      }
    }
  }

  getSelectedAttractLoopChkBx(data, attractLoopId, index: number) {
    //To change checkbox  behaviour like radio button.IIT2-8501
    if (this.selectedIndex != undefined) {
      this.displayAttractorLoop[this.selectedIndex].checked = false;
    }
    this.selectedIndex = index;
    this.displayAttractorLoop[this.selectedIndex].checked = data?.target?.checked;
    this.getSelectedAttractLoopData.emit({ id: attractLoopId, status: data?.target?.checked });
  }

  addToProfile(eventObj: any, index: number) {
    this.displayAttractorLoop.forEach(element => {
      if (element.index === index) {
        element.isChecked = true;
      } else {
        element.isChecked = false;
      }
    });
  }
}
